// La pantalla del Catálogo (ADR-2026-10-13-catalogo-con-el-agente): decide portada o sesión y
// provee los productos del catálogo de la marca activa (`ProductsContext`, que `PickProductPanel`
// lee), como hace Ambiente completo fuera del sheet. Espera a que el rubro resuelva: con
// `brandId` en null, `fetchUserProducts` traería el catálogo de TODA la empresa.
import { useEffect, useState } from 'react';
import { useRubroMarcaActiva } from '../../../../hooks/useRubroMarca';
import { useAgentEnv } from '../../agentEnvContext';
import type { MockProductV2 } from '../../mockData';
import { fetchUserProducts } from '../../productsApi';
import { ProductsContext, ProductsLoadedContext } from '../../productsContext';
import { PortadaDeCatalogo } from './PortadaDeCatalogo';
import { SesionDeCatalogo } from './SesionDeCatalogo';

export const PantallaCatalogo: React.FC<{ sesionId?: string }> = ({ sesionId }) => {
  const { companyId, brandId } = useAgentEnv();
  const { rubro, loaded: rubroCargado } = useRubroMarcaActiva();
  const [productos, setProductos] = useState<MockProductV2[]>([]);
  const [cargados, setCargados] = useState(false);
  // Sube cuando se da de alta un producto desde la tarjeta "Subir nuevo producto": la grilla lo trae.
  const [version, setVersion] = useState(0);

  useEffect(() => {
    if (!companyId || !rubroCargado) return;
    let cancelado = false;
    (async () => {
      try {
        const lista = await fetchUserProducts(companyId, brandId ?? null);
        if (!cancelado) setProductos(lista);
      } catch (e) {
        console.error('[PantallaCatalogo] productos', e);
      } finally {
        if (!cancelado) setCargados(true);
      }
    })();
    return () => {
      cancelado = true;
    };
  }, [companyId, brandId, rubroCargado, version]);

  return (
    <ProductsContext.Provider value={productos}>
      <ProductsLoadedContext.Provider value={cargados}>
        {sesionId ? <SesionDeCatalogo key={sesionId} sesionId={sesionId} /> : <PortadaDeCatalogo rubro={rubro} onProductosNuevos={() => setVersion((v) => v + 1)} />}
      </ProductsLoadedContext.Provider>
    </ProductsContext.Provider>
  );
};
